import { useSocket } from '../../contexts/SocketContext';
import { useEffect, useState } from 'react';
import SoundManager from '../../tools/SoundManager';

export const FlyText = () => {

  const {resultModal: result, setResultModal, winner} = useSocket();

  const [trigger, setTrigger] = useState(0);

  const resultTitle = result === 'safe' 
    ? "You're safe!"
    : result === 'dead'
    ? "You're out!"
    : ((result === 'dead-win' || result === 'other-win') && winner)
    ? `${winner.name} wins!`
    : result === 'lose'
    ? "You lost this round!"
    : result === 'win'
    ? "You win!"
    : result === 'tie'
    ? "It's a tie!"
    : null;

  const subTitle = result === "dead-win" 
    ? "You're out of lives."
    : result === 'tie'
    ? "Round resets."
    : null;

  useEffect(() => {
    if (!result) return;

    // if (result === 'safe') SoundManager.playGameSound('turn_safe');
    // else if (result === 'dead' || result === 'dead-win') SoundManager.playGameSound('turn_dead');
    // else if (result === 'lose') SoundManager.playGameSound('turn_lose');
    // else if (result === 'win') SoundManager.playGameSound('turn_win');

    setTrigger(prev => prev + 1);
  }, [result]);

  return (
    <div
      key={trigger}
      onAnimationEnd={() => setResultModal(false)}
      className="fly-text"
    >
      <div className='item-list small-gap center-horizontal'>
        <span className={"main-text"}>{resultTitle}</span>
        {subTitle && <span className={'sub-text'}>{subTitle}</span>}
      </div>
    </div>
  );
}
